import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";
import router from "./router";
import store from "./store";
import classListPolyfill from "../classListPolyfill";
import VueResource from "vue-resource";

import cs from "./i18n/cs";
import sk from "./i18n/sk";

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(VueResource);

Vue.http.options.root = process.env.VUE_APP_BACKEND_URL;
Vue.http.headers.common["Accept-Language"] = "cs-CZ";
Vue.http.headers.common.Authorization =
  "BEARER " + store.getters.getAccessToken;

let defaultLocale = "cs";

// Get locale from local storage in case isn't defined set locale base on domain name
if (localStorage.getItem("userLocale") !== 'null') {
  defaultLocale = localStorage.getItem("userLocale");
  // In case cordova check phone language
} else if (process.env.BASE_URL === "") {
  if (navigator.language === "sk-sk" || navigator.language === "sk-SK") {
    defaultLocale = "sk";
  } else {
    defaultLocale = "cs";
  }
} else {
  // eslint-disable-next-line
  const domainRegex = /([^.\/]+\.)([^.\/]+)/g;
  const match = domainRegex.exec(window.location.hostname);
  if (match) {
    if (match[2]) {
      defaultLocale = match[2] === "cz" ? "cs" : "sk";
    }
  }
}

navigator.serviceWorker.getRegistrations().then(function(registrations) {
  for (let registration of registrations) {
    registration.unregister();
  }
});

document.addEventListener(
  "deviceready",
  () => {
    store.dispatch("setCordova", true);
  },
  false
);

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: "cs",
  silentFallbackWarn: true,
  messages: {
    cs: cs,
    sk: sk
  }
});

new Vue({
  i18n,
  vuetify,
  router,
  store,
  classListPolyfill,
  render: h => h(App)
}).$mount("#app");
